import WheelTorque from './Torque';
import WheelRemoval from './wheelRemoval';
import React, { useContext } from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import { SecondaryButton } from '../../../../../../../Core/Controls';
import { WheelAndTorqueContext, WheelAndTorqueProvider } from './WheelRemoveContext';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

export default function WheelAndTorque(props) {
    return (
        <WheelAndTorqueProvider {...props}>
            <WheelAndTorqueContent {...props} />
        </WheelAndTorqueProvider>
    );
}

function WheelAndTorqueContent({ isTorque, isDisabled }) {
    const { vehicleDetails, setVehicleDetails, handleSubmit, submitLoader, wheelRemovalState, downloadLoader, handleDownload, loading, hasSavedFittingSignature } =
        useContext(WheelAndTorqueContext);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <div height="100%" style={{ padding: 10, overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                    <WheelRemoval />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                    <WheelTorque />
                </Grid>
                <Grid item xs={12} style={{ marginTop: 14, paddingBottom: 16, display: 'flex', gap: '8px' }}>
                    {!isDisabled && !hasSavedFittingSignature && (
                        <SecondaryButton style={{ flex: 1 }} onClick={() => handleSubmit(false)} isBtnLoader={submitLoader}>
                            Save
                        </SecondaryButton>
                    )}
                    {!isDisabled && (
                        <SecondaryButton style={{ flex: 1 }} onClick={() => handleSubmit(true)} isBtnLoader={submitLoader}>
                            Submit
                        </SecondaryButton>
                    )}
                    {wheelRemovalState?.id && (
                        <SecondaryButton style={{ flex: 1 }} onClick={handleDownload} isBtnLoader={downloadLoader}>
                            <CloudDownloadIcon /> &nbsp; Download PDF
                        </SecondaryButton>
                    )}
                </Grid>
            </Grid>
        </div>
    );
}
